import { Dropdown } from "antd";
import { IconPack } from "Explore/Config/Icons";
import { logout } from "Explore/Services/Auth";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from "./Dropdown.module.scss";
import useDeviceCheck from "Hooks/useDeviceCheck";
import LoginBox from "LandingPage/Components/LoginBox";
import { useState } from "react";
import { Modal } from "@mui/material";

const DropdownNav = ({ landscape }) => {
  const { isMobile } = useDeviceCheck();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.user.data);
  const [isOpenLoginDialog, setIsOpenLoginDialog] = useState(false)
  const handleLogin = () => {
    setIsOpenLoginDialog(true)
  };
  const handleLogout = () => {
    logout();
  };

  const items = [
    {
      key: "login",
      label: user ? (
        <p>Hi, {user.username}</p>
      ) : (
        <div className={styles["login-button"]} onClick={() => handleLogin()}>
          {IconPack.logout}
          <p>Login</p>
        </div>
      ),
    },
    {
      key: "1",
      label: <p>{user?.name}</p>,
    },
    // {
    //   type: "divider",
    // },
    // {
    //   key: "2",
    //   type: "group",
    //   label: "Other services",
    //   children: [
    //     {
    //       key: "2-1",
    //       label: (
    //         <div className={styles["other-services"]}>
    //           {IconPack.public_profile_package}
    //           <Link
    //             to={"https://public-profile.academic.online/home"}
    //             target="_blank"
    //             style={{ color: "black" }}
    //           >
    //             Public profile
    //           </Link>
    //         </div>
    //       ),
    //     },
    //     {
    //       key: "2-2",
    //       label: (
    //         <div className={styles["other-services"]}>
    //           {IconPack.profile_management_package}
    //           <Link
    //             to={"/super-admin/accounts"}
    //             target="_blank"
    //             style={{ color: "black" }}
    //           >
    //             Profile management
    //           </Link>
    //         </div>
    //       ),
    //     },
    //   ],
    // },
    ...(user
      ? [
          {
            type: "divider",
          },
          {
            key: "logout",
            label: (
              <div
                className={styles["logout-button"]}
                onClick={() => handleLogout()}
              >
                {IconPack.logout}
                <p>Logout</p>
              </div>
            ),
          },
        ]
      : []),
  ];
  return (
    <>
      <div
        className={styles["dropdown"]}
      >
        <Dropdown
          menu={{
            items,
          }}
          trigger="click"
        >
          {IconPack.user_profile}
        </Dropdown>
      </div>
      <Modal open={isOpenLoginDialog} onClose={() => setIsOpenLoginDialog(false)}>
        <div className={styles["login-modal"]}>
          <LoginBox />
        </div>
      </Modal>
    </>
  );
};

export default DropdownNav;
